import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IThunkAPI, IUserNotePayload } from '@/store/types';
import { IApplicationNotesList, IApplicationNotesPayload, IApplicationNotesState } from '@/api/types';
import { applicationApi } from '@/api';

const initialState: IApplicationNotesState = {
  applicantNotesList: [],
};

export const getApplicantNotesList = createAsyncThunk<IApplicationNotesList[], IUserNotePayload, IThunkAPI>(
  'get/applicationNotes/list',
  async (payload, thunkAPI) => {
    try {
      const response = await applicationApi.getApplicationNotesByUserId(payload.userId, payload.campaignId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const saveApplicantNotes = createAsyncThunk<unknown, IApplicationNotesPayload, IThunkAPI>(
  'save/note',
  async (payload, thunkAPI) => {
    try {
      const response = await applicationApi.saveApplicationNote(payload);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const deleteApplicantNotes = createAsyncThunk<unknown, IApplicationNotesPayload, IThunkAPI>(
  'delete/note',
  async (payload, thunkAPI) => {
    try {
      const response = await applicationApi.deleteApplicationNote(payload.notesId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const applicantNotesSlice = createSlice({
  name: 'applicantNotes',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getApplicantNotesList.fulfilled, (state, action) => {
      state.applicantNotesList = action.payload;
    });
  },
});

export default applicantNotesSlice.reducer;
